import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';

import { LabelL } from '@sorare/core/src/atoms/typography';

import { ProgressTaskCard } from '#src/components/missions/ProgressTaskCard/index.tsx';
import { useTaskButtonProps } from '#src/components/missions/useTaskButtonProps.tsx';

import type { RaffleTask_taskInterface } from './__generated__/index.graphql.ts';

type Props = {
  task: RaffleTask_taskInterface;
  onClaim: () => void;
  loading: boolean;
};

export const RaffleTask = ({ task, onClaim, loading }: Props) => {
  const { rewardConfigs, progress, target, title } = task;
  const rewardConfig = rewardConfigs.at(0);
  const navigate = useNavigate();
  const { to } = useTaskButtonProps({
    task,
  });

  return (
    <ProgressTaskCard
      task={task}
      onClick={to ? () => navigate(to) : undefined}
      category={<FormattedMessage defaultMessage="Daily" />}
      description={<LabelL>{title}</LabelL>}
      accentColor="var(--c-raffle)"
      accentColorRgb="var(--c-rgb-raffle)"
      titleColor="var(--c-raffle)"
      progress={progress}
      target={target}
      rewardConfig={rewardConfig}
      onClaim={onClaim}
      loading={loading}
    />
  );
};

RaffleTask.fragments = {
  taskInterface: gql`
    fragment RaffleTask_taskInterface on TaskInterface {
      id
      progress
      target
      title
      rewardConfigs {
        id
        ...ProgressTaskCard_anyRewardConfigInterface
      }
      ...ProgressTaskCard_taskInterface
      ...useTaskButtonProps_taskInterface
    }
    ${ProgressTaskCard.fragments.taskInterface}
    ${ProgressTaskCard.fragments.anyRewardConfigInterface}
    ${useTaskButtonProps.fragments.taskInterface}
  ` as TypedDocumentNode<RaffleTask_taskInterface>,
};
